import axios from 'axios';
import { orderBy } from 'lodash';
import { getProcessorsQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { resolveId } from '../../utils';
import Split from '../split';

const getSchedulingProcessors = async () => {
    try {
        const queryBuilder = Split.getBooleanTreatment('use_express_auth_endpoints') ? buildExpressQuery : buildLoopbackQuery;
        const fields = ['id', 'name'];
        const schedulingProcessorsQuery = getProcessorsQuery({ fields, filterDeleted: true, queryBuilder });
        const schedulingProcessorsRequest = axios.get(schedulingProcessorsQuery);

        const { data } = await schedulingProcessorsRequest;
        return orderBy(Array.isArray(data) ? data.map(resolveId) : [], ['name'], ['asc']);
    } catch (err) {
        // eslint-disable-next-line
        console.log(err);
        throw new Error('Unable to process request.');
    }
};

export default getSchedulingProcessors;
